import { Image } from "antd";
import { formatDisplayDateTime, serverImgFullPath } from "../utils/Common";
import EditIcon from "./images/Edit";
import ViewIcon from "./images/View";
import { useNavigate } from "react-router-dom";

export default function RestaurantItemComponent({
  record = {
    id: "",
    _name: "",
    status: "",
    logo: "",
    setIsEditClicked: null,
  },
  setRestaurantId = null,
}) {
  const navigate = useNavigate();

  async function handleDetailViewModalOpen(resId) {
    navigate(`/restaurants/${resId}/details`, {
      state: {
        restaurantId: resId,
      },
    });
  }

  function onHandleEditButton(resId) {
    navigate(`/restaurants/${resId}/edit`, {
      state: {
        restaurantId: resId,
      },
    });
  }

  return (
    <section className="my-3 px-5 bg-[#F1F1F1] rounded-lg">
      <div className="w-full h-[107px] flex items-center space-x-[10px]">
        <div className="mr-[63px] flex items-center rounded-full">
          <Image
            src={serverImgFullPath(record.logo, "/images/temp-res-logo2.png")}
            alt="res-logo"
            width={85}
            height={85}
            className="rounded-full"
            fallback={"/images/temp-res-logo2.png"}
          />
        </div>

        {/* Restaurant Details */}
        <div className="w-full h-[100px] flex items-center">
          <div className="w-[70%] pr-2">
            <h1
              className="font-[700] text-xl text-[#696969] font-p_bold 
              text-[18px] leading-[14.4px] break-words break-all whitespace-normal leading-snug"
            >
              {record._name}
            </h1>
          </div>

          {/* Date, Status, and Buttons */}
          <div className="flex justify-between items-center w-full">
            {/* Date */}
            <div className="text-center">
              <h1
                className="font-[700] text-base text-[#696969] font-p_bold 
                  text-[18px] leading-[14.4px]"
              >
                {formatDisplayDateTime(record.createdAt)}
              </h1>
            </div>

            {/* Status */}
            <div className="flex justify-center items-center">
              {record.status === "Published" ? (
                <div
                  className="capitalize font-p_bold text-[14px] 
                    leading-[16px] tracking-[0.58px] text-[#FCBD10] px-2 text-center"
                >
                  Published
                </div>
              ) : (
                <div className="capitalize font-[500] text-lg text-red-500 px-2 text-center">Pending</div>
              )}
            </div>

            {/* Buttons */}
            <div className="flex space-x-[6px]">
              <ViewIcon
                attributes={{
                  color: "#2EC114",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={() => handleDetailViewModalOpen(record.id)}
              />

              <EditIcon
                attributes={{
                  color: "#572D86",
                  size: "36",
                  classes: "cursor-pointer",
                }}
                clickHandler={() => onHandleEditButton(record.id)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
